/* eslint-disable react/no-array-index-key */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-closing-tag-location */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts';

class PieComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const data = this.props.chartData;
    const COLORS = [
      '#A3B3F9',
      '#B1CDF8',
      '#BBE9FE',
      '#5272AA',
      '#84DAFF',
    ];

    return (
      <ResponsiveContainer height={220} width="100%">
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

PieComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default PieComponent;
